<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{
                $t("configuracion")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("categorias") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("negocio") }}</label>

                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idBusiness"
                    filterable
                    :placeholder="$t('seleccionaNegocio')"
                    @change="getCategory()"
                  >
                    <el-option
                      v-for="business in listBusinesses"
                      class="select-primary"
                      :value="business.id"
                      :label="business.establishmentName"
                      :key="business.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="col-md-8"></div>
            <template v-if="!permiso">
              <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                  Lo sentimos. Este negocio no cuenta con este módulo activado.
              </div>
            </template>
            <template v-else>
              <div class="col-md-3" v-if="respuesta">
                <div class="col-md-12">
                  <div class="form-group">
                    <button class="btn btn-primary col-md-12">
                      1
                    </button>
                  </div>
                </div>
                <div v-for="c in listCategory.slice(0, 10)" class="col-md-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      @change="saveCategory(c)"
                      id="grupo1"
                      placeholder=""
                      v-model="c.name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="respuesta">
                <div class="col-md-12">
                  <div class="form-group">
                    <button class="btn btn-primary col-md-12">
                      2
                    </button>
                  </div>
                </div>
                <div v-for="c in listCategory.slice(10, 20)" class="col-md-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      @change="saveCategory(c)"
                      id="grupo2"
                      placeholder=""
                      v-model="c.name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="respuesta">
                <div class="col-md-12">
                  <div class="form-group">
                    <button class="btn btn-primary col-md-12">
                      3
                    </button>
                  </div>
                </div>
                <div v-for="c in listCategory.slice(20, 30)" class="col-md-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      @change="saveCategory(c)"
                      id="grupo3"
                      placeholder=""
                      v-model="c.name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="respuesta">
                <div class="col-md-12">
                  <div class="form-group">
                    <button class="btn btn-primary col-md-12">
                      4
                    </button>
                  </div>
                </div>
                <div v-for="c in listCategory.slice(30, 40)" class="col-md-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      @change="saveCategory(c)"
                      id="grupo4"
                      placeholder=""
                      v-model="c.name"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Loading } from "element-ui";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Switch,
  CheckboxButton,
  Transfer,
  Steps,
  Step,
} from "element-ui";
import { mapState } from 'vuex'

export default {
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("categorias"));
    this.getBusiness();

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }

    this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
  },

  data() {
    return {
      //PRUEBAS INICIO PAGINA
      loadingGeneral: null,

      data2: [],
      value2: [],

      loading: false,
      listBusinesses: [],
      idBusiness: this.$route.params.idBusiness,
      listCategory: [],
      listCategoryModal: [],
      idCategoryModal: 0,
      idCategoryModal2: 0,
      listPrinter: [],
      respuesta: true,

      //CAMBIO PRECIO
    };
  },
  computed: {
    ...mapState(["permiso"])
  },
  methods: {
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (response.data.response) {
            if (!vm.idBusiness) {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.listBusinesses = response.data.result;
            vm.getCategory();
          } else {
            vm.loadingGeneral.close();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCategory() {
      this.listCategory = [];
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "categories/getCategoryGeneralesByBusinesses",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              if (response.data.result[i].id !== 0) {
                vm.listCategoryModal.push({
                  label: response.data.result[i].name,
                  value: response.data.result[i].id,
                });
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
                code: response.data.result[i].code,
              };

              vm.listCategory.push(categoryname);
            }

            vm.respuesta = true;
            vm.loadingGeneral.close();
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        });
    },
    saveCategory(c) {
      var controller =
        c.id !== 0 ? "editCategoryGeneralById" : "newCategoryGeneralByBusiness";

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        category: c,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;

      this.axios
        .post(
          this.$store.getters.apiUrl + "categories/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            let notify = c.id ? vm.$t("actualizada") : vm.$t("creada");
            vm.$notify({
              message:
                vm.$t("categoria") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            // actualizamos ID creado en database para esa forma y así la próxima vez sea actualizar y no crear
            if (c.id === 0) {
              for (let i = 0; i < vm.listCategory.length; i++) {
                if (vm.listCategory[i].code === c.code) {
                  vm.listCategory[i].id = response.data.result;
                  break;
                }
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [Transfer.name]: Transfer,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}

.wrapperTitleImpresion {
  background-color: rgb(22, 162, 170);
  color: white;
  font-weight: bold;
  padding: 5px 15px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/CategoriasGenerales/CategoriasGenerales.vue